import {WhiteLabel} from "./white-label";

export class WhiteLabelMapper {

  public static map(data: any): WhiteLabel {
    const whiteLabel: WhiteLabel = new WhiteLabel();
    whiteLabel.id = data.id;
    whiteLabel.companyName = data.company_name ? data.company_name : null;
    whiteLabel.cacheIcon = data.cache_icon_big ? data.cache_icon_big : null;
    whiteLabel.cacheText = data.cache_text ? data.cache_text : null;
    whiteLabel.defaultIcon = data.default_icon;
    whiteLabel.allDomains = data.all_domains;
    return whiteLabel;
  }

}
